module.exports = "<p>\r\n  despachos works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/despachos/despachos.component.html
// module id = ../../../../../src/app/components/despachos/despachos.component.html
// module chunks = main